import React from 'react';

const HomePage = () => {
    const company = JSON.parse(localStorage.getItem('company')) || {};
    return (
        <div>
            <h1>Bienvenue sur la page d'accueil .. {company.name || ""}</h1>
        </div>
    );
};

export default HomePage;